import React, { FC } from "react";
import Icon from "newComponents/Shared/_Atoms/Icons/Icon/Icon";
import colors from "constants/colors";
import WhatsNew from "newComponents/Shared/WhatNew/WhatsNew";
import Portal from "layout/Portal/Portal";

interface IProps {
  onClose: () => void;
}

const isBrowser = typeof window !== "undefined";

const WhatsNewModal: FC<IProps> = ({ onClose }) => {
  return (
    isBrowser && (
      <Portal id="whats-new-modal" onClose={onClose}>
        <div className="modal-container" id="news-modal">
          <div className="modal-content">
            <div className="carousel-close-button" onClick={onClose}>
              <Icon icon="close" color={colors.black} />
            </div>
            <WhatsNew fromModal />
          </div>
        </div>
      </Portal>
    )
  );
};

export default WhatsNewModal;
